import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { SourceType } from 'api/page-template/types';
import { FormattedMessage } from 'react-intl';

type PageTemplatesEmptyStateProps = {
  onPrimaryAction: VoidFunction;
  sourceType?: SourceType;
};
export const PageTemplatesNoSearchMatchState = ({
  onPrimaryAction,
  sourceType = SourceType.Meeting,
}: PageTemplatesEmptyStateProps) => {
  const title = `${sourceType.toLowerCase()}_page_templates.empty_state.no_search_results.title`;
  const message = `${sourceType.toLowerCase()}_page_templates.empty_state.no_search_results.message`;

  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={<FormattedMessage id={title} />}
        message={<FormattedMessage id={message} />}
        primaryCTA={
          <EmptyState.CallToAction.Primary
            type="primary"
            onClick={onPrimaryAction}
          >
            <FormattedMessage id="clear_search" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
export const PageTemplatesNoTemplatesState = ({
  onPrimaryAction,
  sourceType = SourceType.Meeting,
}: PageTemplatesEmptyStateProps) => {
  const title = `${sourceType.toLowerCase()}_page_templates.empty_state.no_templates.title`;
  const message = `${sourceType.toLowerCase()}_page_templates.empty_state.no_templates.message`;

  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={<FormattedMessage id={title} />}
        message={<FormattedMessage id={message} />}
        primaryCTA={
          <EmptyState.CallToAction.Primary
            type="primary"
            onClick={onPrimaryAction}
            icon={<FontAwesomeIcon icon={faPlus} size={12} />}
          >
            <FormattedMessage id="new_template" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};

export const NoMeetingsFoundEmptyState = ({
  onPrimaryAction,
  sourceType = SourceType.Meeting,
}: PageTemplatesEmptyStateProps) => {
  const title = `accounts.${sourceType.toLowerCase()}.no_${sourceType.toLowerCase()}_found`;
  const message = `${sourceType.toLowerCase()}_page_templates.empty_state.no_templates.message`;

  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={<FormattedMessage id={title} />}
        message={<FormattedMessage id={message} />}
        primaryCTA={
          <EmptyState.CallToAction.Primary
            type="primary"
            onClick={onPrimaryAction}
            icon={<FontAwesomeIcon icon={faPlus} size={12} />}
          >
            <FormattedMessage id="new_template" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
